const Toast = ({ message, visible }) => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: visible ? "100px" : "-100px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#0E141B",
        color: "white",
        padding: "16px 24px",
        borderRadius: "8px",
        fontSize: "16px",
        fontFamily: '"Noto Sans KR", sans-serif',
        zIndex: 1000,
        transition: "bottom 0.3s ease-in-out",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
        whiteSpace: "pre-line",
        textAlign: "center",
        maxWidth: "80%",
      }}
    >
      {message}
    </div>
  );
};

export default Toast;
